import React, { Fragment } from 'react';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';

import TypograpyHeadingComponent from '../../foundation/typography/typography-heading/typography-heading';
import TypograpyBodyComponent from '../../foundation/typography/typography-body/typography-body';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import { ISubSection } from '../../../typings/hlroom';
import './no-videos-by-filter.scss';
import ContentDivider from '../../atoms/content-divider/content-divider';
import SquareFilterImage from '../../atoms/square-filter-image/square-filter-image';
import useDrag from '../../../hooks/useDrag';

const classNames = (isDesktop: boolean): IClassNames =>
  makeClassNames({
    noVideosByFilter: ['no-videos-by-filter'],
    noVideosByFilterTitle: 'no-videos-by-filter__title',
    noVideosByFilterSubsection: 'no-videos-by-filter__subsection',
    noVideosByFilterDescription: 'no-videos-by-filter__description ty-body-small',
    noVideosByFilterExplore: 'no-videos-by-filter__explore',
    noVideosByFilterWrapper: 'no-videos-by-filter__wrapper',
    noVideosByFilterContainer: 'no-videos-by-filter__container',
    noVideosByFilterDivider: 'no-videos-by-filter__divider',
  });

export interface INoVideosByFilter {
  isDesktop: boolean;
  subSections: ISubSection[];
  subSectionIndex: number;
  subSubSectionIndex?: number;
  onSubSectionChange: (subSection: ISubSection) => void;
}
const texts = {
  title: 'Purtroppo non sono presenti video in questo momento!',
  description: 'Riprova in un altro momento oppure esplora tutte le altre sezioni di Highlight Room',
  sliderTitle: 'Esplora per categoria',
};

const NoVideosByFilter: React.FC<INoVideosByFilter> = ({
  isDesktop,
  subSections,
  subSectionIndex,
  subSubSectionIndex,
  onSubSectionChange,
}) => {
  const { dragStart, dragStop, dragMove, dragging } = useDrag();

  const handleDrag =
    ({ scrollContainer }: any) =>
    (ev: React.MouseEvent) =>
      dragMove(ev, (posDiff) => {
        if (scrollContainer.current) {
          scrollContainer.current.scrollLeft += posDiff;
        }
      });

  const clickOnChip = (subSection: ISubSection) => {
    if (dragging) {
      return false;
    }
    onSubSectionChange(subSection);
    return false;
  };

  return (
    <div className={classNames(isDesktop).noVideosByFilter}>
      <div className={classNames(isDesktop).noVideosByFilterSubsection}>
        <TypograpyHeadingComponent
          customFont="skyHeadline--m"
          headingTag="h2"
          text={
            (subSubSectionIndex &&
              (subSections[subSectionIndex]?.subSubSections?.[subSubSectionIndex]?.name as string)) ||
            (subSections[subSectionIndex]?.name as string) ||
            ''
          }
        />
      </div>
      <div className={classNames(isDesktop).noVideosByFilterTitle}>
        <TypograpyHeadingComponent customFont="skyHeadline--l" headingTag="h2" text={texts.title} />
      </div>
      <TypograpyBodyComponent
        typographyClass={classNames(isDesktop).noVideosByFilterDescription}
        text={texts.description}
      />
      {!subSubSectionIndex && (
        <Fragment>
          <ContentDivider />
          <div className={classNames(isDesktop).noVideosByFilterExplore}>
            <TypograpyHeadingComponent
              customFont="skyHeadline--m"
              headingTag="h2"
              text={(texts?.sliderTitle.toUpperCase() as string) || ''}
            />
          </div>

          <ScrollMenu
            scrollContainerClassName={classNames(isDesktop).noVideosByFilterContainer}
            onMouseDown={() => dragStart}
            onMouseUp={() => dragStop}
            onMouseMove={handleDrag}
            wrapperClassName={classNames(isDesktop).noVideosByFilterWrapper}
          >
            {subSections
              .filter((e) => e.tag)
              .filter((e, i) => e.tag !== subSections[subSectionIndex].tag)
              .map((s, i) => (
                <SquareFilterImage
                  key={i}
                  isDesktop={isDesktop}
                  subSection={s}
                  onClick={() => clickOnChip(s)}
                  customClass="no-videos-by-filter-card"
                />
              ))}
          </ScrollMenu>
          <ContentDivider />
        </Fragment>
      )}
    </div>
  );
};

export default NoVideosByFilter;
